import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledNGPointsToolTip = styled.div`
  .ng-points-tooltip-row {
    margin: ${toRem(10)} auto;
    justify-content: space-around;
    gap: ${toRem(30)};
  }

  .ng-points-tooltip-mobile {
    width: unset;
  }

  .ng-points-tooltip-hidden {
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    height: 0;
    margin: 0;
    overflow: hidden;
  }

  .tooltip-cta-class {
    color: ${baseVariables.color.base20} !important;
    background-color: ${baseVariables.color.merch30};
  }

  .m-popover-bottom {
    gap: ${toRem(12)};
    text-wrap: auto;
  }

  .ng-points-tooltip-desktop {
    width: ${toRem(343)};
    height: ${toRem(152)};
    box-sizing: border-box;
  }

  .ng-points-tooltip-desktop .m-popover-header,
  .ng-points-tooltip-desktop p,
  .ng-points-tooltip-desktop span {
    max-width: 100%;
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
  }
`;
